// extracted by mini-css-extract-plugin
export default {"margin_xs":"hdjzZpOE","margin_s":"I7FAsZTb","margin_m":"jDE2RHjZ","margin_l":"F6xbS9hO","margin_xl":"LNZC1TGR"};